import styled from "@emotion/styled"
import { css } from "@emotion/react"

const dynamicStyle = ({ theme, active }) => css`
  ${active &&
  `position: relative;
  color: ${theme.palette.primary.main};
              &:before {
                  content: "";
                  position: absolute;
                  width: 100%;
                  height: 2px;
                  background:  ${theme.palette.primary.main};
                  bottom: -2px;
                  left: 0;
              }
  `}
`

const ArticleAsideTabsTab = styled.div`
  display: flex;
  font-weight: 500;
  cursor: pointer;
  flex: 1 1 100%;
  font-size: 18px;
  line-height: 120%;
  &:first-child {
    justify-content: flex-start;
  }
  &:last-child {
    justify-content: flex-end;
  }

  ${dynamicStyle}

  ${({ theme }) => theme.breakpoints.down("lg")} {
    padding: 13px 10px;
  }

  ${({ theme }) => theme.breakpoints.between("lg", "2xl")} {
    padding: 16px 12px;
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    padding: 20px 15px;
  }
`

export default ArticleAsideTabsTab
